import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-267">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={onClose} data-id="element-268">
          <motion.div initial={{
        opacity: 0,
        scale: 0.96,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.96,
        y: 10
      }} transition={{
        duration: 0.25,
        ease: 'easeOut'
      }} className="relative bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-269">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-slate-100 shrink-0" data-id="element-270">
              <h2 className="font-heading font-bold text-navy-900 text-lg md:text-xl pr-4" data-id="element-271">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="text-slate-400 hover:text-slate-700 transition-colors p-1 -m-1 rounded-lg hover:bg-slate-100" data-id="element-272">
                <X className="w-6 h-6" data-id="element-273" />
              </button>
            </div>

            {/* Body */}
            <div className="overflow-y-auto px-6 md:px-8 py-6 text-slate-600 text-sm md:text-base leading-relaxed legal-content" data-id="element-274">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}